const firebaseConfig = {
    apiKey: "AIzaSyBJCYpqQ4MNlVmEfkHZADG1PJo4ghK4ncA",
    authDomain: "ema-john-37a08.firebaseapp.com",
    projectId: "ema-john-37a08",
    storageBucket: "ema-john-37a08.appspot.com",
    messagingSenderId: "66268164728",
    appId: "1:66268164728:web:ef53d0988b8f6d5c7a338d"
  };

export default firebaseConfig;